module.exports = [{"id":1,"category":"top","AssessmentName":"PR Coaching and Mentoring","date":"Mon Mar 24 2015 09:00:00 GMT-0700","behaviours":[{"id":33,"Name":"targeted","Score":343},{"id":34,"Name":"reflective","Score":435},{"id":35,"Name":"independent","Score":123}]},{"id":2,"category":"bottom","AssessmentName":"PR Coaching and Mentoring","date":"Wed Mar 24 2015 03:00:00 GMT-0700","behaviours":[{"id":1,"Name":"consistent","Score":214},{"id":2,"Name":"collaborative","Score":478},{"id":3,"Name":"methodical","Score":340}]}]


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/behaviours/topbottombehaviours.json
// module id = 2551
// module chunks = 0